import type { CustomCellRendererProps } from "ag-grid-react";
import { Fragment } from "react";
import { SymbolIcon } from "widgets";

import { nonBreakingSpace } from "../columns/settings.ts";
import { extractValueAsArray } from "../utils/tables.ts";
import { TableCellWrapper } from "./TableCellWrapper.tsx";

export const BooleanListCell = (props: CustomCellRendererProps) => {
  const values = extractValueAsArray(props.value);

  // TODO: Assess differences to original implementation
  //  - Highlight disabled: Skipped because it seems to be never used
  //  - Show lock icon if the cell is  of group type SAMPLE and locked
  //  - Handle cell background color

  return (
    <TableCellWrapper {...props} tooltipValue={values.map((v) => v ?? "").join(", ")} style={{ textAlign: "center" }}>
      {values.map((booleanValue, index) => (
        <Fragment key={`boolean-value-item-${booleanValue}-${index}`}>
          {booleanValue == undefined ? (
            nonBreakingSpace
          ) : (
            <SymbolIcon
              icon={booleanValue ? "check" : "close"}
              style={{ color: booleanValue ? "var(--windows-blue-main)" : "var(--disabled-color)" }}
              data-testid={"yes"}
            />
          )}
          {index < values.length - 1 && ", "}
        </Fragment>
      ))}
    </TableCellWrapper>
  );
};
